<template>
  <button>
    <i class="fas fa-arrow-left tw-text-gray-500" style="font-size: 24px" @click="handleBack" />
  </button>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();

function handleBack() {
  router.push({
    name: "Launcher",
  });
}
</script>
